var _circle, _circle2, _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#FCD1C1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#FCD1C1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F46530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0007 45.3335C48.3207 45.3335 45.334 48.3202 45.334 52.0002C45.334 55.6802 48.3207 58.6668 52.0007 58.6668C55.6807 58.6668 58.6673 55.6802 58.6673 52.0002C58.6673 48.3202 55.6807 45.3335 52.0007 45.3335ZM49.8207 49.1068C50.3607 49.1068 50.8073 49.5468 50.8073 50.0935C50.8073 50.6335 50.3673 51.0802 49.8207 51.0802C49.2807 51.0802 48.834 50.6402 48.834 50.0935C48.834 49.5468 49.274 49.1068 49.8207 49.1068ZM49.9007 54.5335C49.8007 54.6335 49.674 54.6802 49.5473 54.6802C49.4207 54.6802 49.294 54.6335 49.194 54.5335C49.0007 54.3402 49.0007 54.0202 49.194 53.8268L53.5607 49.4602C53.754 49.2668 54.074 49.2668 54.2673 49.4602C54.4607 49.6535 54.4607 49.9735 54.2673 50.1668L49.9007 54.5335ZM54.1807 54.8935C53.6407 54.8935 53.194 54.4535 53.194 53.9068C53.194 53.3668 53.634 52.9202 54.1807 52.9202C54.7207 52.9202 55.1673 53.3602 55.1673 53.9068C55.1673 54.4535 54.7273 54.8935 54.1807 54.8935Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_8417)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_129_8417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.667 44V22.6667C22.667 21.9594 22.9479 21.2811 23.448 20.781C23.9481 20.281 24.6264 20 25.3337 20H38.667C39.3742 20 40.0525 20.281 40.5526 20.781C41.0527 21.2811 41.3337 21.9594 41.3337 22.6667V44L37.3337 41.3333L34.667 44L32.0003 41.3333L29.3337 44L26.667 41.3333L22.667 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.667 44V22.6667C22.667 21.9594 22.9479 21.2811 23.448 20.781C23.9481 20.281 24.6264 20 25.3337 20H38.667C39.3742 20 40.0525 20.281 40.5526 20.781C41.0527 21.2811 41.3337 21.9594 41.3337 22.6667V44L37.3337 41.3333L34.667 44L32.0003 41.3333L29.3337 44L26.667 41.3333L22.667 44Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_129_8417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6663 26.6667H31.333C30.8026 26.6667 30.2939 26.8774 29.9188 27.2525C29.5437 27.6275 29.333 28.1363 29.333 28.6667C29.333 29.1971 29.5437 29.7058 29.9188 30.0809C30.2939 30.456 30.8026 30.6667 31.333 30.6667H32.6663C33.1968 30.6667 33.7055 30.8774 34.0806 31.2525C34.4556 31.6275 34.6663 32.1363 34.6663 32.6667C34.6663 33.1971 34.4556 33.7058 34.0806 34.0809C33.7055 34.456 33.1968 34.6667 32.6663 34.6667H29.333M31.9997 34.6667V36.6667M31.9997 24.6667V26.6667",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_129_8417",
    x: 19.667,
    y: 17,
    width: 28.667,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_8417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_8417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_129_8417",
    x: 26.333,
    y: 21.6667,
    width: 15.333,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_8417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_8417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_8417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.3e42837bee621d38e3e0f9eaf123987f.svg";
export { ForwardRef as ReactComponent };